import { render, staticRenderFns } from "./FormFeriado.vue?vue&type=template&id=76854077"
import script from "./FormFeriado.vue?vue&type=script&lang=js"
export * from "./FormFeriado.vue?vue&type=script&lang=js"
import style0 from "./FormFeriado.vue?vue&type=style&index=0&id=76854077&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports